// extracted by mini-css-extract-plugin
export default {"CommentListPlaceholder":"ih_a bhn_jk","CommentListPlaceholder--Legacy":"ih_b bhn_rc bhn_wq"};